import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { getWalletManagementList } from '../cryptoWalletsEndpoints'
import type { GetWalletManagementParams } from '../../types/cryptoWalletTypes'

export function useWalletManagementListQuery(
  filters: MaybeRefOrGetter<Partial<GetWalletManagementParams>>,
) {
  return useQuery({
    queryKey: () => cryptoWalletsKeys.walletManagementList(toValue(filters)),
    queryFn: () => getWalletManagementList({ page: 1, limit: 10, ...toValue(filters) }),
  })
}
